import { Badge, Button } from "@/atoms"
import { FilterOutlined } from "@/icons"

import styles from "./IconButtonQuickFilter.module.scss"

import type { IconButtonQuickFilterProps } from "."

export const IconButtonQuickFilter = (props: IconButtonQuickFilterProps) => (
  <Badge count={props.count} className={styles.container}>
    <Button
      icon={<FilterOutlined />}
      disabled={props.disabled}
      onClick={props.onClick}
    />
  </Badge>
)
